"use client";
import { jsx as o } from "react/jsx-runtime";
import { cn as l } from "@deputy-ai/common";
import { Progress as r } from "radix-ui";
import * as m from "react";
const n = m.forwardRef(({ className: t, value: a, duration: e, ...s }, i) => /* @__PURE__ */ o(
  r.Root,
  {
    ref: i,
    className: l(
      "bg-primary/20 bottom: 0 left: 0 relative h-0.5 w-full overflow-hidden rounded-full",
      t
    ),
    ...s,
    children: /* @__PURE__ */ o(
      r.Indicator,
      {
        className: "bg-primary h-full transition-all",
        style: {
          transform: `translateX(${(a ?? 0) - 100}%)`,
          transitionDuration: `${e}ms`
        }
      }
    )
  }
));
n.displayName = r.Root.displayName;
export {
  n as ProgressBar
};
